import cloneDeep from 'lodash.clonedeep';

const copy = (obj) => cloneDeep(obj);

const formatUSCurrency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumSignificantDigits: 2,
});

const formatUSCurrencyWithFourDecimals = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 4,
  minimumFractionDigits: 4,
});

const onlyNums = (str) => str.replace(/[^\d.-]/g, '');

const commaEvery3rdChar = (val) => val.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');

// limit the number of characters and numerical value of a given string
function maxCharsAndValue(str, charLimit, valLimit) {
  let newStr = str;
  if (parseInt(newStr, 10) > valLimit) {
    newStr = valLimit.toString();
  }
  if (newStr.length > charLimit) {
    newStr.substring(0, charLimit);
  }
  return newStr;
}

// adds a given character to a string (%, x, yrs...)
function concatCharacter(input, char) {
  return input && (!input.toString().includes(char) ? input.toString() + char : input);
}

const removeCommas = (str) => str.replaceAll(',', '');

function millisecondsToStr(milliseconds) {
  let temp = Math.floor(milliseconds / 1000);
  const years = Math.floor(temp / 31536000);
  if (years) return `${years} year${years > 1 ? 's' : ''}`;
  const days = Math.floor((temp %= 31536000) / 86400);
  if (days) return `${days} day${days > 1 ? 's' : ''}`;
  const hours = Math.floor((temp %= 86400) / 3600);
  if (hours) return `${hours} hour${hours > 1 ? 's' : ''}`;
  const minutes = Math.floor((temp %= 3600) / 60);
  if (minutes) return `${minutes} minute${minutes > 1 ? 's' : ''}`;
  const seconds = temp % 60;
  if (seconds) return `${seconds} second${seconds > 1 ? 's' : ''}`;
  return 'less than a second';
}

export {
  copy,
  formatUSCurrency,
  formatUSCurrencyWithFourDecimals,
  onlyNums,
  commaEvery3rdChar,
  maxCharsAndValue,
  concatCharacter,
  removeCommas,
  millisecondsToStr,
};
